import { render, staticRenderFns } from "./reVisit.vue?vue&type=template&id=45866c43&scoped=true"
import script from "./reVisit.vue?vue&type=script&lang=js"
export * from "./reVisit.vue?vue&type=script&lang=js"
import style0 from "./reVisit.vue?vue&type=style&index=0&id=45866c43&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45866c43",
  null
  
)

export default component.exports